import { SiteSpaConfig } from '@pubstack/common/src/kleanadsScopeConfig'
import { MutationToasts, useMutation, useQuery } from '../api-client'
import { AdmSiteConfig } from '@pubstack/common/src/siteConfig'

export const SITE_CONFIGS_QUERY_KEYS = (keys: string[]) => ['adm', 'sites', ...keys]
const baseUrl = '/adm/sites'
//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useSiteConfig = (siteId?: string) => {
  return useQuery<AdmSiteConfig>({
    url: `${baseUrl}/${siteId}/site-config`,
    keys: SITE_CONFIGS_QUERY_KEYS([siteId ?? '', 'site-config']),
    enabled: !!siteId,
  })
}

export const useSpaConfig = (siteId?: string) => {
  return useQuery<SiteSpaConfig>({
    url: `${baseUrl}/${siteId}/spa-config`,
    keys: SITE_CONFIGS_QUERY_KEYS([siteId ?? '', 'spa-config']),
    enabled: !!siteId,
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------

export const useUpdateSiteConfig = (siteId: string, toasts: MutationToasts = {}) => {
  return useMutation<AdmSiteConfig>({
    method: 'put',
    url: `${baseUrl}/${siteId}/site-config`,
    collectionKeys: SITE_CONFIGS_QUERY_KEYS([siteId ?? '', 'site-config']),
    ...toasts,
  })
}

export const useUpdateSpaConfig = (siteId: string, toasts: MutationToasts = {}) => {
  return useMutation<SiteSpaConfig>({
    method: 'put',
    url: `${baseUrl}/${siteId}/spa-config`,
    collectionKeys: SITE_CONFIGS_QUERY_KEYS([siteId ?? '', 'spa-config']),
    ...toasts,
  })
}
